export enum FeatureName {
  AUTH_DAPP = 'auth-dapp',
  SUBSCRIPTION = 'show-subscription-setting',
  NAVBAR_UI2 = 'navbar-ui2'
}
